/// <amd-module name="VSS/Features/ReduxDirectory/Redux/Favorites/FavoriteActions" />
import { IFavoriteData } from "VSS/Features/Directory/DirectoryContracts";
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum FavoriteActionTypes {
    ToggleFavorite = "Directory/ToggleFavorite",
    BeginAddFavorite = "Directory/BeginAddFavorite",
    AddFavoriteSuccessful = "Directory/AddFavoriteSuccessful",
    AddFavoriteFailed = "Directory/AddFavoriteFailed",
    BeginRemoveFavorite = "Directory/BeginRemoveFavorite",
    RemoveFavoriteSuccessful = "Directory/RemoveFavoriteSuccessful",
    RemoveFavoriteFailed = "Directory/RemoveFavoriteFailed",
    SetFavoritesViewPermission = "Directory/SetFavoritesViewPermission"
}

export const FavoriteActions = {
    toggleFavorite: (artifactId: string, artifactName: string, favoriteId?: string) =>
        createAction(FavoriteActionTypes.ToggleFavorite, { artifactId, artifactName, favoriteId }),
    beginAddFavorite: (artifactId: string) => createAction(FavoriteActionTypes.BeginAddFavorite, artifactId),
    addFavoriteSuccessful: (favorite: IFavoriteData) => createAction(FavoriteActionTypes.AddFavoriteSuccessful, favorite),
    addFavoriteFailed: (artifactId: string, error: Error) => createAction(FavoriteActionTypes.AddFavoriteFailed, { artifactId, error }),
    beginRemoveFavorite: (artifactId: string) => createAction(FavoriteActionTypes.BeginRemoveFavorite, artifactId),
    removeFavoriteSuccessful: (artifactId: string) => createAction(FavoriteActionTypes.RemoveFavoriteSuccessful, artifactId),
    removeFavoriteFailed: (artifactId: string, error: Error) => createAction(FavoriteActionTypes.RemoveFavoriteFailed, { artifactId, error }),
    setFavoritesViewPermission: (permission: boolean) => createAction(FavoriteActionTypes.SetFavoritesViewPermission, { permission })
};

export type FavoriteActions = ActionsUnion<typeof FavoriteActions>;
